<script>
import UserLink from '../../components/UserLink.vue';
import TowerLink from '../../components/TowerLink.vue';
import ContentCard from './ContentCard.vue';

export default {
    props: {
        item: Object
    },
    render(h) {
        const item = this.item;
        const { type, on, by, byname, timestamp, ref } = item;
        const user = <UserLink id={by} name={byname}/>;
        const tower = item.towerTitle ? <TowerLink name={on} title={item.towerTitle} /> : null;
        const outer = (inner) => {
            <div>
                { inner }
                <p>{ this.formatDate(timestamp) }</p>
            </div>
        }
        const prefix = type.split(".")[0];
        switch (prefix) {
        case "break": {
            const { score } = item;
            let addon = ""
            if (item.hard) addon += `${item.hard}难度`;
            if (item.ending) addon += `${item.ending}结局`;
            return (
                <div>
                    { user }在{ tower }{ addon }中以{ score }的成绩夺走了你的榜单
                </div>
            );
        }
        case "update":
        case "follow": {
            return (
                <div>
                    {user}关注了你
                </div>
            );
        }
        case "comment": {
            switch (type) {
            case "comment": {
                const { content } = item;
                return (
                    <div>
                        {user}在{tower}的评论区中发言
                        <div class="comment">
                            { content }
                        </div>
                    </div>
                );
            }
            case "comment.reply":
            case "comment.talk": {
                const { content, tocontent } = item;
                return (
                    <div>
                        {user}在{tower}的评论区中回复了你的评论
                        <a href={`/tower/?name=${ on }#p${ ref }`} target="_blank">
                            <div class="comment">
                                { content || "该评论已被删除" }
                            </div>
                        </a>
                    </div>
                );
            }
            }
            return <div></div>
        }
        case "post": {
            switch (type) {
            case "post": {
                const { bid, tid, pid, page, content } = item;
                return (
                    <div>
                        {user}回复了你的帖子<a href={`/bbs/thread?bid=${bid}&tid=${tid}&p=1`} target="_blank">{item.title}</a>
                        <a href={`/bbs/thread?bid=${bid}&tid=${tid}&p=${page}#p${pid}`} target="_blank">
                            <div class="comment">
                                { content.length <= 140 ? content : (content.substring(0, 140) + "...") }
                            </div>
                        </a>
                    </div>
                );
            }
            case "post.reply": {
                const { bid, tid } = item;
                return (
                    <div>
                        {user}回复了你的帖子<a href={`/bbs/thread?bid=${bid}&tid=${tid}&p=1`} target="_blank">{item.title}</a>
                    </div>
                );
            }
            case "post.talk": {
                const { bid, tid } = item;
                return (
                    <div>
                        {user}回复了你的帖子<a href={`/bbs/thread?bid=${bid}&tid=${tid}&p=1`} target="_blank">{item.title}</a>
                    </div>
                );
            }
            case "post.quote": {
                const { bid, tid } = item;
                return (
                    <div>
                        {user}引用了你的帖子<a href={`/bbs/thread?bid=${bid}&tid=${tid}&p=1`} target="_blank">{item.title}</a>
                    </div>
                );
            }
            }
            return <div></div>
        }
        case "bbs": {
            const { title } = item;
            if (!item.fid) item.fid = 1;
            const page = Math.ceil(item.fid / 10);
            const thread = (<a href={`/bbs/thread/?tid=${ on }&p=1`} target="_blank">{ title }</a>);
            const place = (inner) => (
                <a href={`/bbs/thread/?tid=${ on }&p=${ page }`} target="_blank">{ inner }</a>
            );
            const { content, tocontent } = item;
            const contentCard = (<ContentCard content={ content } tocontent={ tocontent }></ContentCard>)
            switch (type) {
            case "bbs.thread.manage": {
                const { key, value } = item;
                const opt = {
                    'star'  : (e) => [ '取消加精', '加精' ][e],
                    'top'   : (e) => [ '取消置顶', '置顶' ][e],
                    'locked': (e) => [ '取消锁定', '锁定' ][e],
                }[key](value);
                return (
                    <div>
                        你的帖子{ thread }被{ opt }
                    </div>
                );
            }
            case "bbs.thread.delete": {
                return (
                    <div>
                        你的帖子 { title } 被删除
                    </div>
                );
            }
            case "bbs.thread.appendPost":
            case "bbs.thread.appendSubpost": {
                return (
                    <div>
                        { user } 回复了你的帖子 { thread }: 
                        <div>
                            { place(contentCard) }
                        </div>
                    </div>
                );
            }
            case "bbs.post.edit": {
                return (
                    <div>
                        { user } 回复了你的帖子 { thread }: 
                        <div>
                            { place(contentCard) }
                        </div>
                    </div>
                );
            }
            case "bbs.post.delete": 
            case "bbs.subpost.delete": {
                return (
                    <div>
                        你在 { title } 下的回帖被删除
                        { contentCard }
                    </div>
                );
            }
            case "bbs.post.appendSubpost":
            case "bbs.subpost.reply": {
                return (
                    <div>
                        { user} 回复了你在 { thread } 下的回帖
                        { contentCard }
                    </div>
                );
            }
            case "bbs.muteuser": {
                return;
            }
            }
            return <div></div>
        }
        }
        return <div></div>;
    },
    methods: {
        formatDate(timestamp) {
            return (new Date(timestamp * 1000)).toLocaleString("cn-ZH", { hour12: false });
        }
    },
    components: {
        TowerLink,
    }
}
</script>

<style>
.comment {
    color: rgba(0, 0, 0, 0.45);
}
</style>